import { ReactComponent as StrmCycleIcon } from "shared/assets/images/icon-strm-cycle.svg";

interface CycleFooterNoteProps {
  text: string;
}

const CycleFooterNote: React.FC<CycleFooterNoteProps> = ({ text }) => {
  return (
    <div className="cycles-footer-note">
      <span className="cycles-footer-note__icon" aria-hidden="true">
        <StrmCycleIcon />
      </span>
      <p className="cycles-footer-note__text body-regular">{text}</p>
    </div>
  );
};

export default CycleFooterNote;
